import './App.scss';
import './index.scss';

import { Suspense, useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';

import CircularProgress from '@material-ui/core/CircularProgress';
import { map } from 'lodash-es';
import { Provider } from 'react-redux';
import store from './Redux/store';
import {
  commonRouteMap,
  privateRouteMap,
  publicRouteMap,
  customerRouteMap,
  adminRouteMap,
  fraudprivateRouteMap
} from './routes';
import PrivateRoute from './routes/PrivateRoute';
import PublicRoute from './routes/PublicRoute';
import CommonRoute from './routes/CommonRoute';
import AdminRoute from './routes/AdminRoute';
import CustomerRoute from 'routes/CustomerRoute';
import { app, db, auth } from './firebaseConfig';

import { getMessaging, getToken } from 'firebase/messaging';
import FraudprivateRoute from 'routes/FraudRoute';
import TermsGuard from 'shared/guards/TermsGuard';
import { initClarity } from 'utils/clarityTracking';
import { userStore } from 'store/UserStore';

// import initMessaging from '/firebase-messaging-sw';

// import initMessaging from '../public/firebase-messaging-sw'

type Props = {};

const App = (props: Props) => {

  const [customerId, user] = userStore((state: any) => [
    state.customerId,
    state.user,
    state.customer,
  ]);

    useEffect(() => {
    // if ('serviceWorker' in navigator) {
    //   navigator.serviceWorker.addEventListener('message', (event) => {
    //     console.log('event for the service worker', event);
    //   });
    // }
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker
          .register('/firebase-messaging-sw.js')
          .then((registration) => {
            // console.log('Service Worker registered:', registration);
          })
          .catch((error) => {
            console.error('Service Worker registration failed:', error);
          });
      });
    }
  }, []);

    useEffect(() => {
    const id = user?.userId || customerId;
    if (!id) return;
    initClarity(id);
  }, [user?.userId, customerId]);

  return (
    <Provider store={store}>
      <Router>
        <Suspense
          fallback={
            <CircularProgress
              className="loading"
              disableShrink
              color="inherit"
            />
          }
        >
          <Switch>

            {/* Public + Common Routes (No Terms Required) */}
            {map(commonRouteMap, (route) => (
              <CommonRoute
                key={`commonRouter-${route.path}`}
                exact
                path={route.path}
                component={route.component}
              />
            ))}

            {map(publicRouteMap, (route) => (
              <PublicRoute
                key={`publicRouter-${route.path}`}
                exact
                path={route.path}
                component={route.component}
              />
            ))}

            <TermsGuard>

              {map(customerRouteMap, (route) => (
                <CustomerRoute
                  key={`customerRouter-${route.path}`}
                  exact
                  path={route.path}
                  component={route.component}
                />
              ))}

              {map(privateRouteMap, (route) => (
                <PrivateRoute
                  key={`privateRouter-${route.path}`}
                  exact
                  path={route.path}
                  component={route.component}
                />
              ))}

              {map(adminRouteMap, (route) => (
                <AdminRoute
                  key={`adminRouter-${route.path}`}
                  exact
                  path={route.path}
                  component={route.component}
                />
              ))}

              {map(fraudprivateRouteMap, (route) => (
                <FraudprivateRoute
                  key={`fraudprivateRouter-${route.path}`}
                  exact
                  path={route.path}
                  component={route.component}
                />
              ))}

            </TermsGuard>

          </Switch>
        </Suspense>
      </Router>
    </Provider>
  );
};

export default App;
